import { type Setter, Show, createEffect, createSignal } from "solid-js";
import { useDocumentContext } from "../../../providers/context";
import { DocumentTocDesktop } from "./desktop";
import { DocumentTocMobile } from "./mobile";

interface DocumentTocProps {
	screen: "mobile" | "desktop";
}

export function DocumentToc(props: DocumentTocProps) {
	const [accordion, setAccordion] = createSignal<string[]>([]);

	const { sections, selected } = useDocumentContext();

	createEffect(() => {
		const article = selected();
		const toc = sections();

		if (!article) {
			return;
		}

		const section = toc.find((section) => section.articles.some((a) => a.id === article.id));
		setAccordion(section ? [section.heading.id] : []);
	});

	return (
		<Show
			when={props.screen === "desktop"}
			fallback={<DocumentTocMobile />}
		>
			<DocumentTocDesktop
				accordion={accordion()}
				setAccordion={setAccordion}
			/>
		</Show>
	);
}

export interface DocumentTocChildProps {
	accordion: string[];
	setAccordion: Setter<string[]>;
}
